import { SET_ITEMS, SET_ITEM_TYPES } from "../actions/types";

const initialState = {
  items: [],
  itemTypes: [],
};

const itemReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ITEM_TYPES: {
      return {
        ...state,
        itemTypes: action.data,
      };
    }
    case SET_ITEMS: {
      return {
        ...state,
        items: action.data,
      };
    }
    default:
      return state;
  }
};

export default itemReducer;
